import React, { useState } from 'react';
import ArrowLgButton from '../Global/ArrowLgButton';
import RichText from '../Global/RichText';
//@ts-ignore
import * as styles from './product-detail-highlight.module.css';
//@ts-ignore
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { ProductHighlight } from '../../templates/StructuredDataContext';
import { ProductDetailHighlightProps } from '.';
import { getMediaData } from '../Global/DataUtils';
import { getImageData } from '../Global/DataUtils/gatsbyImageUtils';
import { useIsClient } from '../Global/DataUtils/useIsClient';
import {
    optimizeKontentImageUrl,
    buildKontentSrcSet,
    getDisplayDimensions,
} from '../Global/DataUtils';
import LazyImage from '../Global/LazyImage';

import ReactPlayer from '../Global/LazyReactPlayer';

const ProductDetailHighlight: React.FC<ProductDetailHighlightProps> = ({
    product_highlights,
    kontentItemId,
}) => {
    const highlights = product_highlights.value;
    const [currentHighlight, setCurrentHighlight] = useState(0);
    const breakpoints = useBreakpoint();
    const isClient = useIsClient();
    const arrowStrokeColor = '#f3660b';

    const handleClickNext = () => {
        if (currentHighlight === highlights.length - 1) {
            setCurrentHighlight(0);
        } else {
            const nextHighlight = currentHighlight + 1;
            setCurrentHighlight(nextHighlight);
        }
    };

    const handleClickPrev = () => {
        if (currentHighlight === 0) {
            const prevHighlight = highlights.length - 1;
            setCurrentHighlight(prevHighlight);
        } else {
            const prevHighlight = currentHighlight - 1;
            setCurrentHighlight(prevHighlight);
        }
    };

    const highlightClass =
        highlights.length === 1 ? styles.soloHighlight : styles.highlight;
    const wrapperClass = highlights.length === 1 ? undefined : styles.wrapper;

    const isLargeScreen = isClient && breakpoints.l;

    const renderHighlight = (highlight: ProductHighlight, idx: number) => {
        const isActive = idx === currentHighlight;
        const shouldShow = isLargeScreen || isActive;
        if (!shouldShow) return null;

        const selection =
            highlight.elements.content_selection?.value[0]?.codename;

        const imageData = getImageData(highlight.elements?.image);
        const video = highlight.elements.video_url;
        const imageWidth = idx === 0 ? 1088 : 812;

        return (
            <div className={highlightClass} key={idx}>
                {selection !== 'video' && imageData?.image && (
                    <LazyImage
                        src={
                            imageData.image
                                ? optimizeKontentImageUrl(
                                      (imageData.image?.url ||
                                          imageData.image) as string,
                                      {
                                          w: imageWidth,
                                          fit: 'crop',
                                          q: 80,
                                          auto: 'format',
                                      }
                                  )
                                : ''
                        }
                        srcSet={
                            imageData.image
                                ? buildKontentSrcSet(
                                      (imageData.image?.url ||
                                          imageData.image) as string,
                                      imageWidth,
                                      { fit: 'crop', q: 80, auto: 'format' }
                                  )
                                : ''
                        }
                        sizes={`(max-width: ${imageWidth}px) 100vw, ${imageWidth}px`}
                        alt={imageData.alt}
                        {...getDisplayDimensions(
                            imageData.image.width,
                            imageData.image.height,
                            imageWidth
                        )}
                        data-kontent-element-codename="image"
                        className={styles.highlightImage}
                        style={{
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                )}

                {selection === 'video' && video && (
                    <div className={styles.highlightVideo}>
                        <ReactPlayer
                            playing={true}
                            width="100%"
                            height="100%"
                            previewTabIndex={1}
                            url={video.value}
                            muted={true}
                        />
                    </div>
                )}

                <div className={styles.highlightContent}>
                    {!isLargeScreen && highlights.length > 1 && idx === 1 ? (
                        <ArrowLgButton
                            direction="left"
                            handleClick={handleClickPrev}
                            strokeColor={arrowStrokeColor}
                            className={styles.prev}
                        />
                    ) : null}
                    <div className={styles.highlightDescription}>
                        {highlight.elements.highlight_description &&
                            RichText(
                                highlight.elements.highlight_description,
                                undefined,
                                undefined,
                                undefined,
                                'highlight_description'
                            )}
                    </div>
                    {!isLargeScreen && highlights.length > 1 && idx === 0 ? (
                        <ArrowLgButton
                            direction="right"
                            handleClick={handleClickNext}
                            strokeColor={arrowStrokeColor}
                            className={styles.next}
                        />
                    ) : null}
                </div>
            </div>
        );
    };

    return (
        <section className={wrapperClass} data-kontent-item-id={kontentItemId}>
            <div className={styles.highlights}>
                {highlights &&
                    highlights.map((highlight, idx) => {
                        return renderHighlight(highlight, idx);
                    })}
            </div>
        </section>
    );
};

export default ProductDetailHighlight;
